import { baseUrlAssets as assets } from "./endpoints";
import { Endpoint } from "lib/types/Endpoint";
import { ViewScopeType } from "lib/types/views/ViewScopeType";

export const endpointsViews = {
  views: `${assets}/views`,
  viewById: (viewId: number): string => `${assets}/views/${viewId}`,
  projectViews: (projectId: number): string =>
    `${assets}/projects/${projectId}/views`,
  projectViewsByScope: (
    projectId: number,
    scopeType: ViewScopeType,
    scopeId?: string,
  ): string => {
    const url = `${assets}/projects/${projectId}/views?scopeType=${scopeType}`;
    return scopeId ? `${url}&scopeId=${scopeId}` : url;
  },
  snapshotCreatePending: (projectId: number, snapshotId: string): Endpoint => ({
    method: "PUT",
    url: `${assets}/projects/${projectId}/snapshot/pending/${snapshotId}`,
  }),
  snapshot: (projectId: number, snapshotId: string): string =>
    `${assets}/projects/${projectId}/snapshot/${snapshotId}`,
  annotatedSnapshot: (
    projectId: number,
    snapshotId: string,
    annotatedSnapshotId: string,
  ): string =>
    `${assets}/projects/${projectId}/snapshot/${snapshotId}/annotated/${annotatedSnapshotId}`,
  snapshotThumbnail: (projectId: number, snapshotId: string): string =>
    `${assets}/projects/${projectId}/snapshot/${snapshotId}/thumbnail`,
  annotatedSnapshotThumbnail: (
    projectId: number,
    snapshotId: string,
    annotatedSnapshotId: string,
  ): string =>
    `${assets}/projects/${projectId}/snapshot/${snapshotId}/annotated/${annotatedSnapshotId}/thumbnail`,
};
